import "./static/css/bootstrap.min.css";
import "./static/owl-carousel/dist/assets/owl.carousel.min.css";
import "./static/owl-carousel/dist/assets/owl.theme.default.min.css";
import "./static/css/style.css";
import "./src/styles/prism-theme.css";

// Import and expose jQuery globally
import jQuery from "jquery";
global.jQuery = jQuery;
window.jQuery = jQuery;

// Dynamically load Owl Carousel and other scripts
export const onInitialClientRender = () => {
    const scriptUrls = [
        "/owl-carousel/dist/owl.carousel.min.js", // Owl Carousel script
        "/js/bootstrap.min.js",
        "/js/font-awesome-5.js",
        "/js/custom.js", // Your custom script
    ];

    scriptUrls.forEach((src) => {
        const script = document.createElement("script");
        script.src = src;
        script.type = "text/javascript";
        script.async = false; // Load scripts in order
        document.body.appendChild(script);
    });
};
